import script from "./EditorLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorLoading.vue?vue&type=script&setup=true&lang=js"

import "./EditorLoading.vue?vue&type=style&index=0&id=69bbbe99&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69bbbe99"]])

export default __exports__